var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _rect2, _path10, _rect3, _path11, _rect4, _path12, _rect5, _path13, _rect6, _path14, _rect7, _path15, _rect8, _path16, _rect9, _path17, _rect10, _path18, _rect11, _path19, _rect12, _rect13, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroHomeSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 400,
    viewBox: "0 0 720 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 359.5,
    cy: 144.5,
    r: 107.5,
    fill: "#D2B487"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 141.146C0 141.146 154.242 128.842 234 144.058C298.25 156.315 299.789 128.556 379.5 134.383C442.93 139.019 547.25 116 606 116C664.75 116 720 141.146 720 141.146V400H0V141.146Z",
    fill: "#F2EBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 217.954C0 217.954 60.3071 201.629 142.5 201.786C223.229 201.94 304 239.235 391 217.954C446.563 204.363 567 192.136 604 197.147C641 202.157 720 217.954 720 217.954V400H0V217.954Z",
    fill: "#E4D7C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M521.099 201.355C532.596 201.355 532.918 201.355 554.913 201.355C433.118 210.875 393.067 408.504 393.067 408.504H289C289 408.504 411.78 201.355 521.099 201.355Z",
    fill: "#F2EBDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M631.435 161.899C631.435 161.012 630.842 160.234 629.987 159.999L573.178 144.396C572.937 144.329 572.71 144.217 572.51 144.066L537.726 117.683C536.772 116.959 535.398 117.248 534.815 118.294L514.126 155.416C513.963 155.71 513.877 156.04 513.877 156.375V200.01C513.877 201.098 514.759 201.98 515.847 201.98H629.465C630.553 201.98 631.435 201.098 631.435 200.01V161.899Z",
    fill: "#C08A8A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M631.654 162.049C631.654 161.15 631.046 160.365 630.176 160.141L573.46 145.524C572.214 145.202 570.999 146.144 570.999 147.431V200.136C570.999 201.223 571.881 202.105 572.969 202.105H629.684C630.772 202.105 631.654 201.223 631.654 200.136V162.049Z",
    fill: "#B57878"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M598.258 136.766C598.207 136.732 598.151 136.705 598.092 136.686L536.722 117.208C536.014 116.983 535.536 117.923 536.135 118.363L573.146 145.541C573.213 145.59 573.288 145.626 573.369 145.647L632.229 160.978C632.945 161.165 633.374 160.207 632.759 159.796L598.258 136.766Z",
    fill: "#E4D7C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M720 315.612C720 315.612 605 291.659 522.5 303.092C431.809 315.661 358.762 309.584 269 311.984C177 314.444 152 300.249 93 300.249C34 300.249 0 315.612 0 315.612V400H720V315.612Z",
    fill: "#E2DCD8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.37 96.1899H122.821L120.683 57.2559H113.507L111.37 96.1899Z",
    fill: "#6D6363"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.29023,
    height: 20.6121,
    transform: "matrix(1 0 0 -1 116.027 65.5007)",
    fill: "#6D6363"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.82 0H111.369L113.507 38.934H120.683L122.82 0Z",
    fill: "#6D6363"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.29023,
    height: 20.6121,
    transform: "matrix(-1 0 0 1 118.24 29.7731)",
    fill: "#6D6363"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69 53.8205V42.3693L107.934 44.5069V51.6829L69 53.8205Z",
    fill: "#6D6363"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 99.6892,
    y: 49.1637,
    width: 2.29023,
    height: 20.6121,
    transform: "rotate(-90 99.6892 49.1637)",
    fill: "#6D6363"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M165.19 42.3693V53.8205L126.256 51.6829V44.5069L165.19 42.3693Z",
    fill: "#6D6363"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 135.417,
    y: 46.9498,
    width: 2.29023,
    height: 20.6121,
    transform: "rotate(90 135.417 46.9498)",
    fill: "#6D6363"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M155.883 77.1011L161.609 67.1841L126.822 49.5682L123.234 55.7829L155.883 77.1011Z",
    fill: "#6D6363"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.29023,
    height: 20.6121,
    transform: "matrix(0.5 -0.866025 -0.866025 -0.5 131.634 57.7237)",
    fill: "#6D6363"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3057 19.0891L72.5801 29.0061L107.367 46.6219L110.955 40.4073L78.3057 19.0891Z",
    fill: "#6D6363"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.29023,
    height: 20.6121,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 101.8 37.9424)",
    fill: "#6D6363"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3062 77.1011L72.5806 67.1841L107.367 49.5682L110.955 55.7829L78.3062 77.1011Z",
    fill: "#6D6363"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 102.556,
    y: 57.7237,
    width: 2.29023,
    height: 20.6121,
    transform: "rotate(-120 102.556 57.7237)",
    fill: "#6D6363"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M155.884 19.0891L161.609 29.0061L126.823 46.6219L123.235 40.4072L155.884 19.0891Z",
    fill: "#6D6363"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 132.389,
    y: 37.9424,
    width: 2.29023,
    height: 20.6121,
    transform: "rotate(60 132.389 37.9424)",
    fill: "#6D6363"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M136.184 92.6093L146.101 86.8837L124.783 54.2347L118.568 57.8227L136.184 92.6093Z",
    fill: "#6D6363"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2.29023,
    height: 20.6121,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 124.873 63.7034)",
    fill: "#6D6363"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0056 3.58069L88.0886 9.30628L109.407 41.9553L115.621 38.3673L98.0056 3.58069Z",
    fill: "#6D6363"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 2.29023,
    height: 20.6121,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 108.925 31.6553)",
    fill: "#6D6363"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0056 92.6093L88.0886 86.8837L109.407 54.2346L115.621 57.8227L98.0056 92.6093Z",
    fill: "#6D6363"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 109.317,
    y: 63.7034,
    width: 2.29023,
    height: 20.6121,
    transform: "rotate(-150 109.317 63.7034)",
    fill: "#6D6363"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M136.184 3.58069L146.101 9.30628L124.783 41.9553L118.568 38.3673L136.184 3.58069Z",
    fill: "#6D6363"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 125.264,
    y: 31.6553,
    width: 2.29023,
    height: 20.6121,
    transform: "rotate(30 125.264 31.6553)",
    fill: "#6D6363"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 116.152,
    y: 47.1519,
    width: 67.8987,
    height: 1.88608,
    fill: "#6D6363"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M180.278 37.7215L218 33.9493L211.399 45.2658L218 57.5253L180.278 54.6962V37.7215Z",
    fill: "#6D6363"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M117.095 172.576V145.228M117.095 145.228L81.9814 171.338C81.4404 171.74 80.6972 171.228 80.8805 170.579L92.5757 129.196M117.095 145.228L141.614 129.196M117.095 145.228V112.222M117.095 145.228L92.5757 129.196M92.5757 129.196L154.043 171.398C154.599 171.78 155.323 171.238 155.114 170.596L141.614 129.196M92.5757 129.196L102.006 99.0191M92.5757 129.196L117.095 112.222M92.5757 129.196H141.614M141.614 129.196L117.095 112.222M141.614 129.196L132.183 99.0191M102.006 99.0191L117.095 112.222M102.006 99.0191L108.316 77.3293M102.006 99.0191L125.873 77.3293M117.095 112.222L132.183 99.0191M117.095 112.222V47.152M132.183 99.0191L108.316 77.3293M132.183 99.0191L125.873 77.3293M117.095 47.152L108.316 77.3293M117.095 47.152L125.873 77.3293",
    stroke: "#6D6363",
    strokeWidth: 0.706162
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroHomeSm);
export default __webpack_public_path__ + "static/media/hero-home-sm.7e77004f.svg";
export { ForwardRef as ReactComponent };